export default __webpack_public_path__ + "static/media/profile.8bf5dfc8.svg";